import React from "react";
import { GH_COLORS } from "./Style";

type Direction = "horizontal" | "vertical";

interface RoundBoxProps {
  label?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
  direction?: Direction; // 요소 배치 방향
  gap?: number;
}

const RoundBox: React.FC<RoundBoxProps> = ({
  label,
  children,
  style = {},
  contentStyle = {},
  direction = "vertical",
  gap = 10,
}) => {
  const boxContainerStyle: React.CSSProperties = {
    border: `1px solid ${GH_COLORS.border}`,
    borderRadius: 6,
    background: GH_COLORS.canvas,
    padding: label ? "20px 16px 16px 16px" : "16px",
    marginBottom: "12px",
    boxShadow: "0 1px 0 rgba(31,35,40,0.04)",
    position: "relative",
    width: "100%",
    boxSizing: "border-box",
    overflow: "visible",
    ...style,
  };

  const labelStyle: React.CSSProperties = {
    position: "absolute",
    top: "-12px",
    left: 16,
    background: "#fff",
    padding: "2px 10px",
    fontWeight: 600,
    color: GH_COLORS.fgDefault,
    fontSize: 14,
    whiteSpace: "nowrap",
    pointerEvents: "none",
    border: `1px solid ${GH_COLORS.border}`,
    borderRadius: 4,
    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
  };

  const contentLayout: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignItems: "flex-start",
    gap,
    width: "100%",
    boxSizing: "border-box",
    ...contentStyle,
  };

  return (
    <div style={boxContainerStyle}>
      {label && <span style={labelStyle}>{label}</span>}
      <div style={contentLayout}>{children}</div>
    </div>
  );
};

export default RoundBox;
